import React, { FC, useState } from 'react';
import { ArchivePageSidebarProps } from './ArchivePageSidebarProps';
import { Stack } from '@mui/material';
import CountrySelect from '../CountrySelect';
import SidebarLayout from '../../common/SidebarLayout';

const ArchivePageSidebar: FC<ArchivePageSidebarProps> = ({
  selectedCountryCodes,
  onCountryCodeChange,
  countryList,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <SidebarLayout
      mainItem={() => (
        <Stack direction={'column'} spacing={2}>
          <CountrySelect
            selectedCountryCodes={selectedCountryCodes}
            hidden={!drawerOpen}
            onCountryCodeChange={onCountryCodeChange}
            countryList={countryList}
          />
        </Stack>
      )}
      drawerOpen={drawerOpen}
      setDrawerOpen={setDrawerOpen}
    />
  );
};

export default ArchivePageSidebar;
